import { render, staticRenderFns } from "./NameStatus.vue?vue&type=template&id=61b685d4"
import script from "./NameStatus.vue?vue&type=script&lang=js"
export * from "./NameStatus.vue?vue&type=script&lang=js"
import style0 from "./NameStatus.vue?vue&type=style&index=0&id=61b685d4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports